
import styles from './app-template-root-layout.module.scss';
import React from 'react';
import { AppNotifications } from '@revenuewell/logic-notification';
import { AppConfirmation } from '@revenuewell/logic-confirmation';

type IProps = {
  className?: string
  ready: boolean,
  children?: React.ReactNode
}
export const AppTemplateRootLayout: React.FC<IProps> = (
  {
    className,
    ready,
    children
  }) => {

  return <>
    <div
      className={`${styles['app-template-root']}
              ${className ? className : ''}
              ${ready ? styles['ready'] : ''}`}
    >
      {children}
    </div>
    <AppNotifications />
    <AppConfirmation />
  </>
}
